module.exports = __webpack_public_path__ + "img/note-danger.3955f84e.svg";